module.exports = __webpack_public_path__ + "media/images/icons/icon_192-76af85f84918c0ac21bdd1ab836173c6.png";